import { Injectable } from '@angular/core';
import { MainService } from './main.service';
import { CampaignModel } from '../models/campaigns.model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MonitoringService {

    constructor(
        private main: MainService
    ) { }


    getCampaingsMonitoringList(){
        return this.main.getRequest("/monitoring/campaigns").pipe(
          map((resp: any) => {
            let campaignList: Array<CampaignModel> = [];
            if(resp.message == "Success") {          
              resp.data.forEach((e:any) => {
                campaignList.push(e);
              });
            }     
            return campaignList;
          })
        );
    }


    getMonitoringData(id:number){
        return this.main.getRequest(`/monitoring/show/${ id.toString() }`).pipe(
          map((resp: any) => {
            console.log(resp.data);  
            return resp;
          })
        );
    }

    getPaqueteriaData(paq: string, id_camp: number){
      return this.main.getRequest(`/monitoring/distributions-by-carrier/${paq}/${id_camp}`);
    }

    getRecoleccionesData(id_camp: number, ver_por: string, ver_por2: string){
      return this.main.getRequest(`/monitoring/recolecciones/${id_camp}/${ver_por}/${ver_por2}`);
    }
    getRecoleccionesTarde(ver_por: string, id_distribuciones: any, campaign_id: number, ver_por2: string){
      return this.main.postRequest({ ver_por, id_distribuciones, campaign_id, ver_por2}, "/monitoring/recolecciones_tarde");
    }
    getCajasRechazadasData(id_camp: number, fecha_actual: string){
      return this.main.getRequest(`/monitoring/boxes_rechazadas/${id_camp}/${fecha_actual}`);
    }

    getGeneralData(id:number){
      return this.main.getRequest(`/monitoring/generalData/${ id.toString() }`);
    }
    getPeriodos(id:number){
      return this.main.getRequest(`/monitoring/periodos/${ id.toString() }`);
    }
    getProgresoCajas(id:number){
      return this.main.getRequest(`/monitoring/progreso_cajas/${ id.toString() }`);
    }
    getProgresoArchivo(id:number){
      return this.main.getRequest(`/monitoring/progreso_archivo/${ id.toString() }`);
    }
    getProgresoPaqueteria(id:number){
      return this.main.getRequest(`/monitoring/progreso_paqueteria/${ id.toString() }`);
    }
    getProgresoTamanos(id:number){
      return this.main.getRequest(`/monitoring/progreso_tamanos/${ id.toString() }`);
    }
    getRecolecciones(id:number){
      return this.main.getRequest(`/monitoring/get_recolecciones/${ id.toString() }`);
    }
    getCajasProcesadasPorLinea(id:number){
      return this.main.getRequest(`/monitoring/cajas_procesadas_x_linea/${ id.toString() }`);
    }
    getCumplimientoDeObjetivos(id:number){
      return this.main.getRequest(`/monitoring/cumplimiento_de_objetivos/${ id.toString() }`);
    }
    getDefectosCalidad(id:number){
      return this.main.getRequest(`/monitoring/defectos_calidad/${ id.toString() }`);
    }
    getCajasRechazadas(id:number){
      return this.main.getRequest(`/monitoring/cajas_rechazadas/${ id.toString() }`);
    }
    getPicksStation(id:number){
      return this.main.getRequest(`/monitoring/comparativa_picks/${ id.toString() }`);
    }
    getRankingPosiciones(id:number){
      return this.main.getRequest(`/monitoring/ranking_posiciones/${ id.toString() }`);
    }
    getProgresoCalidad(id:number){
      return this.main.getRequest(`/monitoring/progreso_calidad/${ id.toString() }`);
    }

}